// extracted by mini-css-extract-plugin
export default {"sendMessageContainer":"SendMessage_sendMessageContainer__L2hts","actionBtnsContainer":"SendMessage_actionBtnsContainer__5XDLC","actionBtn":"SendMessage_actionBtn__oRZPu"};